module.exports = __webpack_public_path__ + "img/infoguidance_mov_10.6784e6dd.jpg";